<template>
  <a-row type="flex" class="main-content" align="middle">
    <a-col :span="24">
      <ul class="skills-block">
        <li v-for="(item, index) in skillsList" :key="'skills' + index">
          <div class="skills-img-container">
            <img :src="item.imgSrc" />
          </div>
          <div class="skills-article">
            <div class="skills-name">
              <span>{{ item.name }}</span>
            </div>
            <Progress
              :stroke-color="{
                from: '#36629d',
                to: '#3ecfdf'
              }"
              :percent="item.progressPercent"
              :strokeWidth="12"
              status="active"
            />
          </div>
        </li>
      </ul>
    </a-col>
  </a-row>
</template>
<script>
import Progress from "ant-design-vue/lib/progress";
import iconHTMLCSS from "../../assets/img/icon-html5&css3.svg";
import iconJavascript from "../../assets/img/icon-javascript.svg";
import iconJquery from "../../assets/img/icon-jquery.svg";
import iconReact from "../../assets/img/icon-react.svg";
import iconScss from "../../assets/img/icon-scss.svg";
import iconGit from "../../assets/img/icon-git.svg";
import iconVue from "../../assets/img/icon-vue.svg";
import iconUiLibrary from "../../assets/img/icon-ui-library.svg";
import iconJest from "../../assets/img/icon-jest.svg";

export default {
  name: "fullpageSection1",
  props: ["isfullpagetranslate"],
  components: { Progress },
  data() {
    return {
      skillsList: [
        {
          name: "HTML / CSS",
          imgSrc: iconHTMLCSS,
          progressPercent: 0,
          percent: 90
        },
        {
          name: "Javascript",
          imgSrc: iconJavascript,
          progressPercent: 0,
          percent: 80
        },
        {
          name: "Bootstrap / Element UI",
          imgSrc: iconUiLibrary,
          progressPercent: 0,
          percent: 80
        },
        {
          name: "jQuery",
          imgSrc: iconJquery,
          progressPercent: 0,
          percent: 80
        },
        {
          name: "SCSS",
          imgSrc: iconScss,
          progressPercent: 0,
          percent: 70
        },
        {
          name: "React",
          imgSrc: iconReact,
          progressPercent: 0,
          percent: 70
        },
        {
          name: "Git",
          imgSrc: iconGit,
          progressPercent: 0,
          percent: 70
        },
        {
          name: "Vue",
          imgSrc: iconVue,
          progressPercent: 0,
          percent: 60
        },
        {
          name: "Jest",
          imgSrc: iconJest,
          progressPercent: 0,
          percent: 60
        },
        {
          name: "Vuex / Pinia",
          imgSrc: iconVue,
          progressPercent: 0,
          percent: 60
        }
      ]
    };
  },
  methods: {
    progressHandle() {
      this.skillsList.forEach((item, index, array) => {
        array[index].progressPercent = array[index].percent;
      });
    }
  },
  watch: {
    isfullpagetranslate(now) {
      if (now) {
        this.progressHandle();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  .skills-block {
    display: flex;
    flex-wrap: wrap;

    > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 45px;
      width: 50%;

      &:nth-of-type(2n + 1) {
        padding-right: 2vw;
      }
      .skills-img-container {
        padding: 10px;
        background-color: #b0ebf2;
        border-radius: 7px;

        img {
          // width: 50px;
          width: 3vw;
        }
      }
      .skills-article {
        width: calc(100% - 95px);
        font-family: Impact, sans-serif;
      }
    }
  }
}
</style>

<!-- 非scope樣式-->
<style lang="scss">
.skills-article {
  .ant-progress-outer {
    position: relative;
    padding: 0;

    .ant-progress-bg {
      transition: all 1s cubic-bezier(0.3, 0.6, 0.8, 1) 0s;
    }
  }
  .skills-name {
    font-size: 1.5rem;
    margin-bottom: 5px;
    > span {
      display: inline-block;
      max-width: 185px;
    }
  }
  .ant-progress-text {
    position: absolute;
    right: 0;
    bottom: 25px;
    font-size: 1.5rem;
    letter-spacing: 1px;
    color: #3ecfdf;
  }
}
</style>
